import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-ui-search',
  templateUrl: './ui-search.component.html'
})
export class SearchComponent implements OnInit {

  /* Mod */
  @Input() searchables:any = ["Name","Email"];

  /* Old */
  @Input() type:string = 'inbox';
  @Input() sampleSearchPlaceholder:string = 'Intimation Number';
  searchHasData:boolean = false;
  searchTerm: string = '';
  constructor() { }

  ngOnInit() {
  }
  
  rows:any = [];
  addRow() {
    var objDummy = {};
    this.rows.push(objDummy);
    this.searchHasData = true; 
  }
  removeRow(){
    this.rows.pop();
    if(0==this.rows.length && !this.searchTerm) this.searchHasData = false;
  }
  modelChanged(e) {
    if(this.searchTerm) this.searchHasData = true;
    else if(0==this.rows.length) this.searchHasData = false;
  }

  clearAll(){
    this.rows = [];
    this.searchTerm = '';
    this.searchHasData = false;
  }

}
